import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import apiService from "../Services/apiService";
import ReportService from "../Services/ReportService";
import '../styles/ManageSurvey.css';
import '../styles/Sidebar.css';
import * as XLSX from "xlsx";
import { Modal, Box, Typography } from '@mui/material';
import Chart from 'chart.js/auto';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import QRCode from "qrcode";
import { Button, Stack } from '@mui/material';

const ManageSurvey = () => {
    const [questionDetails, setQuestionDetails] = useState([]); // Corrected naming convention
    const [loading, setLoading] = useState(true);
    const { uniqueKey } = useParams();
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("Survey");
    const [SurveyName, SetSurveyName] = useState("");

    const [SurveyDecription, SetSurveyDecription] = useState("");
    const [ImgURL, SetImgURL] = useState("");
    const [alertMessage, setAlertMessage] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [showErrorAlert, setshowErrorAlert] = useState(false);

    const [CanView, SetCanView] = useState(0);
    const [CanEdit, SetCanEdit] = useState(0);
    const [CanEnd, SetCanEnd] = useState(0);
    const [IsEnded, SetIsEnded] = useState(0);
    const [respondersCount, setrespondersCount] = useState(0);
    const [DeliveredCount, setDeliveredCount] = useState(0);
    const [StartedCount, setStartedCount] = useState(0);
    const [CapturedCount, setCapturedCount] = useState(0);
    const [CompletedCount, setCompletedCount] = useState(0);
    const [AverageTime, setAverageTime] = useState("0");
    const [SurveyStatus, setSurveyStatus] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isOpenScheduleModal, setisOpenScheduleModal] = useState(false);
    const [thankYouNote, setThankYouNote] = useState('');

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [startImmediately, setStartImmediately] = useState(false);
    const [ViewReport, setViewReport] = useState(true);
    const [CreateManageBtnText, setCreateManageBtnText] = useState("");
    const [MsgofData, setMsgofData] = useState(false);
    const [errors, setErrors] = useState({
        thankYouNote: '',
        startDate: '',
        startTime: '',
        endDate: '',
        endTime: ''
    });
    const [removedQuestionIDs, setRemovedQuestionIDs] = useState([]);
    const [DeleteQuestionID, SetDeleteQuestionID] = useState("");
    const [Success, setSuccess] = useState(0);

    const handleTabChange = (tab) => setActiveTab(tab);

    useEffect(() => {
        if (token) {
            const fetchQuestionData = async () => {
                try {
                    const response = await apiService.GetQuestionDetails(token, uniqueKey);
                    if (response && response.SURVEY_DETAILS[0]) {
                        setQuestionDetails(response.SURVEY_DETAILS);
                        setSuccess(0);
                        console.log(questionDetails)

                    } else {
                        console.error("No survey details found");
                    }
                } catch (error) {
                    console.error("Error fetching survey data", error);
                } finally {
                    setLoading(false);
                }
            };
            const GetAuthorization = async () => {
                const response = await apiService.GetAccess(token, uniqueKey);
                if (response) {
                    const surveyDetails = response.SURVEY_DETAILS;
                    const SuveryInsights = response.SURVEY_INSIGHTS
                    console.log(surveyDetails);
                    console.log(SuveryInsights)
                    var SurveyName = surveyDetails[0].SurveyName;
                    var CanEdit = surveyDetails[0].CanEdit;
                    var CanView = surveyDetails[0].CanView;
                    var CanEnd = surveyDetails[0].CanEnd;
                    var SurveyDecription = surveyDetails[0].SurveyDescription;
                    var SurveyStatus = surveyDetails[0].SurveyStatus;
                    var ImgURL = surveyDetails[0].ThumbnailImageURL;
                    var ThankUNote = surveyDetails[0].ThankYouNote;
                    var SurveyEndDateTime = surveyDetails[0].SurveyEndDateTime;
                    var SurveyStartDateTime = surveyDetails[0].SurveyStartDateTime;
                    const startDateTime = parseDateString(SurveyStartDateTime);
                    const endDateTime = parseDateString(SurveyEndDateTime);

                    if (startDateTime && endDateTime) {
                        // If the parsed Date objects are valid, format them
                        setStartDate(formatDate(startDateTime));
                        setEndDate(formatDate(endDateTime));
                        setStartTime(formatTime(startDateTime));
                        setEndTime(formatTime(endDateTime));
                    } else {
                        console.error("Invalid date format, unable to parse.");
                    }
                    setThankYouNote(ThankUNote);
                    SetImgURL(ImgURL)
                    SetSurveyDecription(SurveyDecription);
                    SetCanEdit(CanEdit);
                    setSurveyStatus(SurveyStatus);
                    if (SurveyStatus != "Incomplete") {
                        SetCanEdit(0);
                    }
                    SetCanView(CanView);
                    SetCanEnd(CanEnd);
                    SetIsEnded(CanEnd);
                    SetSurveyName(SurveyName);
                    setrespondersCount(SuveryInsights[0].RespondersCount);
                    setDeliveredCount(SuveryInsights[0].DeliveredCount);
                    setStartedCount(SuveryInsights[0].StartedCount);
                    setCapturedCount(SuveryInsights[0].CapturedCount);
                    setCompletedCount(SuveryInsights[0].CompletedCount);
                    setAverageTime(SuveryInsights[0].AverageTime);
                }
            }
            GetAuthorization();
            fetchQuestionData();
        } else {
            navigate("/Login");
        }
    }, [token, uniqueKey, Success]);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because getMonth() is zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const formatTime = (date) => {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };
    const parseDateString = (dateString) => {
        const parsedDate = new Date(dateString); // Convert to Date object
        if (isNaN(parsedDate)) {
            console.error(`Invalid date string: ${dateString}`);
            return null; // Return null if invalid
        }
        return parsedDate;
    };
    const handleOptionTypeChange = (questionId, newOptionType) => {
        setQuestionDetails((prevDetails) =>
            prevDetails.map((question) =>
                question.QuestionID === questionId
                    ? { ...question, OptionType: newOptionType }
                    : question
            )
        );
    };

    const renderQuestionInput = (question) => {
        if (question.OptionType) {
            return (
                <select
                    value={question.OptionType}
                    disabled={CanEdit === 0}
                    onChange={(e) => CanEdit !== 0 && handleOptionTypeChange(question.QuestionID, e.target.value)} // Conditionally handle change
                    className="Sanket-DropDownControl w-40 mb-3"
                >
                    <option value="Multiple Choice">Multiple Choice</option>
                    <option value="Check Boxes">Check Boxes</option>
                    <option value="Short Answer">Short Answer</option>
                    <option value="Paragraph">Paragraph</option>
                    <option value="Date">Date</option>
                    <option value="Answer in Number">Answer in Number</option>
                    <option value="Mobile Number">Mobile Number</option>
                    <option value="Email">Email</option>
                    <option value="Rating bar">Rating bar</option>
                </select>
            );
        }
    };

    const renderOption = (question) => {
        const handleDeleteOption = (questionID, indexToRemove) => {
            setQuestionDetails((prevDetails) =>
                prevDetails.map((q) =>
                    q.QuestionID === questionID
                        ? {
                            ...q,
                            Options: q.Options.filter((_, index) => index !== indexToRemove),
                        }
                        : q
                )
            );
        };
        const handleAddOption = (questionID, isOther = false) => {
            setQuestionDetails((prevDetails) =>
                prevDetails.map((q) => {
                    if (q.QuestionID !== questionID) return q;

                    const hasOther = q.Options.some((option) => option.OptionName.trim().toLowerCase() === "other");
                    if (isOther && hasOther) {
                        alert("This question already has an 'Other' option.");
                        return q;
                    }

                    let updatedOptions = [...q.Options];

                    if (updatedOptions.length < 10) {
                        updatedOptions.push({ OptionName: isOther ? "Other" : "", isOther });
                    }

                    // Ensure "Other" is always the last item
                    const normalOptions = updatedOptions.filter((opt) => !opt.isOther);
                    const otherOption = updatedOptions.find((opt) => opt.isOther);

                    return {
                        ...q,
                        Options: otherOption ? [...normalOptions, otherOption] : normalOptions,
                    };
                })
            );
        };


        return (
            <div className="my-3">
                {question.Options && question.Options.length > 0 ? (
                    question.Options.map((option, index) => (
                        <div className="option-item ps-4 my-3" key={index}>
                            <input
                                type="text"
                                name={question.QuestionID}
                                id={`${question.QuestionID}-${index}`}
                                className="Sanket-Control w-40"
                                value={option.OptionName || ""}
                                onChange={(e) => {
                                    const newValue = e.target.value.trim().toLowerCase();

                                    setQuestionDetails((prevDetails) =>
                                        prevDetails.map((q) => {
                                            if (q.QuestionID === question.QuestionID) {
                                                const newOptions = q.Options.map((opt, idx) => {
                                                    if (idx === index) {
                                                        return {
                                                            ...opt,
                                                            OptionName: opt.isOther || newValue === "other" ? "Other" : e.target.value,
                                                            isOther: opt.isOther || newValue === "other",
                                                        };
                                                    }
                                                    return opt;
                                                });

                                                return { ...q, Options: newOptions };
                                            }
                                            return q;
                                        })
                                    );
                                }}
                                readOnly={option.isOther || option.OptionName.trim().toLowerCase() === "other" || CanEdit === 0}
                            />
                            {
                                CanEdit !== 0 && (
                                    <a href="#" className="ms-2 text-danger" onClick={(e) => { e.preventDefault(); handleDeleteOption(question.QuestionID, index) }}><i className="fa-solid fa-trash"></i></a>
                                )
                            }
                        </div>
                    ))

                ) : (
                    <p className="mb-0">No options available</p>
                )}
                {question.Options.length < 10 &&
                    (question.OptionType === "Multiple Choice" || question.OptionType === "Check Boxes") && (
                        CanEdit !== 0 && (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-light mt-3 me-2"
                                    onClick={() => handleAddOption(question.QuestionID)}
                                >
                                    Add Option
                                </button>
                                {!question.Options.some((option) => option.OptionName.trim().toLowerCase() === "other") && (
                                    <button
                                        type="button"
                                        className="btn btn-light mt-3"
                                        onClick={() => handleAddOption(question.QuestionID, true)}
                                    >
                                        Add "Other"
                                    </button>
                                )}
                            </>
                        )
                    )}

            </div>
        );
    };

    const moveItem = (index, direction) => {
        const newQuestionDetails = [...questionDetails];
        if (direction === "up" && index > 0) {
            [newQuestionDetails[index - 1], newQuestionDetails[index]] = [
                newQuestionDetails[index],
                newQuestionDetails[index - 1],
            ];
        } else if (direction === "down" && index < newQuestionDetails.length - 1) {
            [newQuestionDetails[index], newQuestionDetails[index + 1]] = [
                newQuestionDetails[index + 1],
                newQuestionDetails[index],
            ];
        } else {
            console.log("Cannot move item in that direction.");
        }

        setQuestionDetails(newQuestionDetails);
        updateSequence(newQuestionDetails);
    };

    const updateSequence = (details) => {
        const newSequence = details.map((item) => item.QuestionSequence);
        // const updatedQuestions = details.map((item) => item.QuestionName);
        console.log("Updated sequence:", newSequence.join(","));
    };
    const handleCheckboxChange = (questionId) => {
        setQuestionDetails((prevDetails) =>
            prevDetails.map((question) =>
                question.QuestionID === questionId
                    ? { ...question, IsRequired: !question.IsRequired }
                    : question
            )
        );
    };
    const handleCopyQuestion = (questionId) => {
        setQuestionDetails((prevDetails) => {
            const questionToCopy = prevDetails.find((q) => q.QuestionID === questionId);
            if (questionToCopy) {
                const copiedQuestion = {
                    ...questionToCopy,
                    QuestionID: Date.now().toString().slice(-8),
                    QuestionName: `${questionToCopy.QuestionName} (Copy)`,
                    Options: questionToCopy.Options.map((option) => ({ ...option })),
                };
                setAlertMessage("Question copied successfully!");
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 4000);
                return [...prevDetails, copiedQuestion];
            }
            return prevDetails;
        });
    };
    const handleDropdownAction = (questionId, action) => {
        if (action === "Activate/Deactivate") {
            setQuestionDetails((prevDetails) =>
                prevDetails.map((question) =>
                    question.QuestionID === questionId
                        ? { ...question, Status: !question.Status }
                        : question
                )
            );
        } else if (action === "Copy") {
            handleCopyQuestion(questionId);
        }
    };
    const handleAddQuestion = () => {
        const newQuestion = {
            QuestionID: Date.now().toString().slice(-8),
            QuestionName: "",
            OptionType: "Short Answer",
            Options: [],
            IsRequired: true,
            Status: true,
        };

        setQuestionDetails((prevDetails) => [...prevDetails, newQuestion]);
    };
    const handleRemoveQuestion = (questionID) => {
        setQuestionDetails((prevDetails) =>
            prevDetails.filter((question) => question.QuestionID !== questionID)
        );
        setRemovedQuestionIDs((prevIDs) => [...(prevIDs || []), questionID]);
        const removedIDsString = [...(removedQuestionIDs || []), questionID].join(",");
        SetDeleteQuestionID(removedIDsString);
        console.log("All Removed Question IDs:", removedIDsString);
    };
    const validateQuestions = () => {
        for (const question of questionDetails) {
            if (!question.QuestionName || question.QuestionName.trim() === "") {
                return false;
            }
            if (
                question.OptionType === "Multiple Choice" ||
                question.OptionType === "Check Boxes"
            ) {
                if (!question.Options || question.Options.length === 0) {
                    return false;
                }
                for (const option of question.Options) {
                    if (!option.OptionName || option.OptionName.trim() === "") {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    const handleSaveSurvey = async () => {
        if (!validateQuestions()) {
            setAlertMessage("Please fill out all question names and options before saving.");
            setshowErrorAlert(true);
            setTimeout(() => setshowErrorAlert(false), 4000);
            return;
        }
        try {
            const payload = {
                Token: token,
                SurveyUID: uniqueKey,
                QuestionData: questionDetails,
                QuestionIDs: DeleteQuestionID
            };
            const response = await apiService.ManageSurveyQuestions(payload);
            if (response) {
                setAlertMessage("Survey saved successfully!");
                setShowAlert(true);
                setTimeout(() => setShowAlert(false), 4000);
            } else {
                alert("Failed to save survey. Please try again.");
            }
        } catch (error) {
            console.error("Error saving survey:", error);
            alert("Error please try after some time");
        }
    };

    const ExportSurveyReport = async () => {
        try {
            const response = await ReportService.ExportSurveyReport(token, uniqueKey);
            if (response) {
                const questions = Object.keys(response.RESPONSE[0]);

                const surveyData = response.RESPONSE.map(survey =>
                    questions.map(question => survey[question])
                );

                const finalData = [questions, ...surveyData];

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Survey Responses');

                finalData.forEach((row, index) => {
                    const newRow = worksheet.addRow(row);

                    if (index === 0) {
                        newRow.eachCell(cell => {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: '3fb390' }
                            };
                            cell.font = {
                                bold: true,
                                color: { argb: 'FFFFFFFF' } // White text
                            };
                            cell.alignment = { horizontal: 'center', vertical: 'middle' };
                        });
                    }
                });

                worksheet.columns = questions.map((q, i) => ({
                    header: q,
                    key: `col${i}`,
                    width: Math.max(
                        15,
                        ...finalData.map(row => (row[i] ? row[i].toString().length : 10))
                    )
                }));

                const buffer = await workbook.xlsx.writeBuffer();
                const now = new Date();
                const formattedDate = now.toISOString().replace(/[-T:.]/g, '');
                const filename = `${SurveyName}_${formattedDate}.xlsx`;

                saveAs(new Blob([buffer]), filename);
                console.log('Exported successfully to Excel!');
            }
        } catch (error) {
            console.error(error);
        }
    };
    const ShowReport = async () => {
        try {
            const response = await ReportService.GetSurveyReport(token, uniqueKey);
            if (response && response.STATUS === "SUCCESS") {
                console.log(response);

                const surveyData = response.RESPONSE;

                const chartsContainer = document.getElementById('charts-container');
                chartsContainer.innerHTML = '';

                surveyData.forEach((survey, index) => {
                    const questionText = survey.Question;
                    const answers = survey.Responses;

                    const questionSection = document.createElement('div');
                    questionSection.classList.add('Chart-card');
                    chartsContainer.appendChild(questionSection);

                    const questionTitle = document.createElement('h6');
                    questionTitle.classList.add('text-justify')
                    questionTitle.textContent = questionText;
                    questionSection.appendChild(questionTitle);

                    // Create and display options with counts and percentages
                    // const optionsList = document.createElement('ul');
                    // answers.forEach(answer => {
                    //     const listItem = document.createElement('li');
                    //     listItem.textContent = `${answer.Answer}: ${answer.AnswerCount} (${answer.AnswerPercentage}%)`;
                    //     optionsList.appendChild(listItem);
                    // });

                    // questionSection.appendChild(optionsList);

                    // Create the pie chart canvas
                    const canvas = document.createElement('canvas');
                    canvas.id = `chart-${index}`;
                    questionSection.appendChild(canvas);

                    // Generate pie chart
                    createPieChart(answers, `chart-${index}`);
                });
                setViewReport(false);
                debugger;
                if (surveyData.length > 0) {
                    setCreateManageBtnText("Manage Formula");
                    setMsgofData(false);
                } else {
                    setCreateManageBtnText("Create Formula")
                    setMsgofData(true);
                }
                console.log('Charts displayed successfully!');
            }
        } catch (error) {
            console.error(error);
        }
    };
    const renderTabContent = () => {
        switch (activeTab) {
            case "Insights":
                return (<>
                    <div className="bg-grey">
                        <div className="flex-column justify-content-evenly align-items-center d-flex min-hight75vh">
                            <h3 className="fw-bolder">Ongoing <span className="fs-18 fw-6">status</span></h3>
                            <div className="mt-3 mb-4 w-100 justify-content-around align-self-center d-flex">
                                {/* Delivered */}
                                <div className="text-center">
                                    <div className="message-label text-center h4">{DeliveredCount}/{respondersCount}</div>
                                    <div className="message-label text-center">Delivered</div>
                                </div>

                                {/* Started */}
                                <div className="text-center">
                                    <div className="message-label text-center h4">{StartedCount}/{DeliveredCount}</div>
                                    <div className="message-label text-center">Started</div>
                                </div>

                                {/* Completed */}
                                <div className="text-center">
                                    <div className="message-label text-center h4">{CompletedCount}/{StartedCount}</div>
                                    <div className="message-label text-center">Completed</div>
                                </div>

                                {/* Response Captured */}
                                <div className="text-center">
                                    <div className="message-label text-center h4">{CapturedCount}</div>
                                    <div className="message-label text-center">Response Captured</div>
                                </div>

                                {/* Average Completion Time */}
                                <div className="text-center">
                                    <div className="message-label text-center h4">{AverageTime}</div>
                                    <div className="message-label text-center">Average Completion Time</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>);
            case "Survey":
                return (<>
                    {/* --survey-- */}
                    <div className="container mt-5">
                        <div className="card col-12 col-lg-8 shadow-sm mx-auto mt-3 p-5">
                            <input type="text" value={SurveyName} className="Sanket-Control mb-3" onChange={(e) => SetSurveyName(e.target.value)} required readOnly={CanEdit === 0} />
                            <input type="text" value={SurveyDecription} className="Sanket-Control mb-3" onChange={(e) => SetSurveyDecription(e.target.value)} required readOnly={CanEdit === 0} />
                            <div className="row">
                                <div className="img-set">
                                    <img src={ImgURL} alt="..." className="w-100 h-100" />
                                </div>
                                {
                                    CanEdit !== 0 && (
                                        <>
                                            <div>
                                                <input type="file" accept=".jpg, .gif, .png, .bmp" onChange={handleFileupload} />
                                            </div>

                                            <div className="text-start">
                                                <button className="btn px-5 btn-custom mt-5" onClick={(e) => { e.preventDefault(); updateSurvey(); }}>Update</button>
                                            </div>
                                        </>
                                    )
                                }
                            </div>

                        </div>

                        <div className="card col-12 col-lg-8 shadow-sm mx-auto mt-3 p-5">
                            {questionDetails.map((question, index) => (
                                <div className="QuestionContainer mb-3" key={question.QuestionID}>
                                    <div className="p-4">
                                        {renderQuestionInput(question)}
                                        <div className="survey-question">
                                            <div className="d-flex gap-2 align-items-center">
                                                {index + 1}
                                                <input
                                                    value={question.QuestionName}
                                                    readOnly={CanEdit === 0}
                                                    onChange={(e) => CanEdit !== 0 && setQuestionDetails((prevDetails) =>
                                                        prevDetails.map((q) =>
                                                            q.QuestionID === question.QuestionID
                                                                ? { ...q, QuestionName: e.target.value }
                                                                : q
                                                        )
                                                    )}
                                                    className="Sanket-Control"
                                                />
                                            </div>
                                        </div>
                                        {renderOption(question)}
                                    </div>
                                    <div className="text-end m-0 p-3" style={{ borderTop: "1px solid #ccc" }}>
                                        Required
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                id="toggleCheckbox"
                                                checked={question.IsRequired}
                                                disabled={CanEdit === 0}
                                                onChange={() => CanEdit !== 0 && handleCheckboxChange(question.QuestionID)} // Conditionally handle change
                                            />
                                            <span className={`slider round  ${CanEdit === 0 ? 'bg-secondary' : ''}`}></span>
                                        </label>
                                        <button
                                            className={`ActionBtns ${CanEdit === 0 ? 'text-secondary' : 'text-dark'}`}
                                            onClick={() => moveItem(index, "up")}
                                            disabled={CanEdit === 0}
                                        >
                                            <i className="fa-solid fa-arrow-up"></i>
                                        </button>
                                        <button
                                            className={`ActionBtns ${CanEdit === 0 ? 'text-secondary' : 'text-dark'}`}
                                            onClick={() => moveItem(index, "down")}
                                            disabled={CanEdit === 0}
                                        >
                                            <i className="fa-solid fa-arrow-down"></i>
                                        </button>
                                        <button href="#" disabled={CanEdit === 0} className={`ActionBtns ms-2 ${CanEdit === 0 ? 'text-secondary' : 'text-dark'}`} onClick={(e) => { e.preventDefault(); handleRemoveQuestion(question.QuestionID) }}><i className="fa-solid fa-trash"></i></button>
                                        <button
                                            className={`ActionBtns ${CanEdit === 0 ? 'text-secondary' : 'text-dark'}`}
                                            disabled={CanEdit === 0}
                                            href="#"
                                            onClick={() => handleDropdownAction(question.QuestionID, "Copy")}
                                        >
                                            <i className="fa-solid fa-clone"></i>
                                        </button>
                                        <button
                                            className={`ActionBtns ${CanEdit === 0 ? 'text-secondary' : 'text-dark'}`}
                                            href="#"
                                            disabled={CanEdit === 0}
                                            onClick={() => handleDropdownAction(question.QuestionID, "Activate/Deactivate")}
                                        >
                                            {question.Status ? <i className="fa-solid fa-eye"></i> : <i className="fa-solid fa-eye-slash"></i>}
                                        </button>
                                    </div>
                                </div>
                            ))}
                            <p className="">
                                {CanEdit === 1 && (
                                    <a
                                        className="btn btn-light me-3"
                                        onClick={handleAddQuestion}
                                    >
                                        Add New Question
                                    </a>
                                )}
                                <button href="#" className="btn btn-custom" onClick={(e) => {
                                    e.preventDefault();
                                    handleSaveSurvey();
                                }} disabled={CanEdit === 0}>Save Draft</button>
                            </p>
                        </div>
                    </div>
                </>);
            case "Reports":
                return <div className="min-hight75vh mt-5">
                    {
                        SurveyStatus === "Survey Ended" ? (<>

                            <div className="text-center">
                                <button className="TruveyHoverBtn" onClick={ExportSurveyReport}><i className="fa-solid fa-down-long"></i> Export Survey Report</button>
                                {
                                    ViewReport ? (<>
                                        <button className="freebtn br-none border-0 ms-3" onClick={ShowReport}>View Survey Analysis</button>
                                    </>) : (<>
                                        <Link className="freebtn br-none border-0 ms-3" to={"/ManageFormula/" + uniqueKey}>{CreateManageBtnText}</Link>
                                    </>)
                                }
                            </div>
                            {
                                MsgofData ? (<>
                                    <div className="text-center my-5">
                                        <Link to={"/ManageFormula/" + uniqueKey}>Formula Not Created Please Click to Create Formula</Link>
                                    </div>
                                </>) : (<>
                                </>)
                            }
                            <div id="charts-container">
                            </div>
                        </>)
                            :
                            (<>
                                <div className="text-center">
                                    The report will be generated after the survey end.
                                </div>
                            </>)
                    }
                </div>;
        };
    }
    const handleFileupload = (e) => {
        const file = e.target.files[0];
        SetImgURL(file);
    }
    const updateSurvey = async () => {
        const updateform = new FormData();
        updateform.append("Token", token);
        updateform.append("SurveyName", SurveyName);
        updateform.append("SurveyDescription", SurveyDecription);
        updateform.append("SurveyUID", uniqueKey);
        updateform.append("Image", ImgURL);
        try {
            const response = await apiService.UpdateSurvey(updateform);
            if (response) {
                console.log(response);
                alert("Updated successfully");
            } else {
                alert("Not Updated successfully");
            }
        } catch (error) {
            console.log(error);
            alert(error);
        }
    }
    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };
    const closeSidebar = () => {
        setIsOpen(false);
    };
    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => setIsModalOpen(false);
    const SchedulehandleOpen = () => setisOpenScheduleModal(true);
    const SchedulehandleClose = () => setisOpenScheduleModal(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'thankYouNote':
                setThankYouNote(value);
                break;
            case 'startDate':
                setStartDate(value);
                break;
            case 'endDate':
                setEndDate(value);
                break;
            case 'startTime':
                setStartTime(value);
                break;
            case 'endTime':
                setEndTime(value);
                break;
            default:
                break;
        }
    };
    const validateForm = () => {
        const newErrors = {};
        let isValid = true;
        const currentDate = new Date();
        const startDateTime = startImmediately ? new Date() : new Date(`${startDate}T${startTime}`);
        debugger;
        // Validate Thank You Note
        if (!thankYouNote.trim()) {
            newErrors.thankYouNote = 'Thank you note is required';
            isValid = false;
        }

        if (!startImmediately) {
            if (!startDate) {
                newErrors.startDate = 'Start date is required';
                isValid = false;
            }
            if (SurveyStatus !== "Active" || SurveyStatus !== "Active") {
                if (new Date(startDateTime) < currentDate) {
                    newErrors.startDate = 'Start datetime cannot be in the past';
                    isValid = false;
                }
            }

            if (!startTime) {
                newErrors.startTime = 'Start time is required';
                isValid = false;
            }
        }

        if (!endDate) {
            newErrors.endDate = 'End date is required';
            isValid = false;
        } else {
            const endDateTime = new Date(`${endDate}T${endTime}`);

            if (endDateTime <= startDateTime) {
                newErrors.endDate = 'End datetime must be after start date and time';
                isValid = false;
            }
        }

        if (!endTime) {
            newErrors.endTime = 'End time is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const formatCurrentDateTime = (dateObj) => {
        const formattedDate = `${dateObj.getFullYear()}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${String(dateObj.getDate()).padStart(2, '0')}`;
        const formattedTime = `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;

        return `${formattedDate} ${formattedTime}`;
    };
    const formatStartDateTime = (dateString, timeString) => {
        if (!dateString || !timeString) {
            return '';
        }

        // Combine dateString and timeString into a Date object
        const [year, month, day] = dateString.split('-');
        const [hours, minutes] = timeString.split(':');
        const dateObj = new Date(year, month - 1, day, hours, minutes);

        // Format the date and time into dd/mm/yy hh:mm:ss
        const formattedDate = `${dateObj.getFullYear()}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${String(dateObj.getDate()).padStart(2, '0')}`;
        const formattedTime = `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;

        return `${formattedDate} ${formattedTime}`;
    };
    const HandletoPublish = async () => {
        var FinalStartDate = null;
        if (validateForm()) {
            debugger;
            if (startImmediately) {
                const currentDate = new Date();
                const formattedDateTime = formatCurrentDateTime(currentDate);
                FinalStartDate = formattedDateTime;
            } else {
                FinalStartDate = formatStartDateTime(startDate, startTime)
            }
            const FinalendDate = formatStartDateTime(endDate, endTime)
            const response = await apiService.PublishSurvey(token, uniqueKey, FinalStartDate, FinalendDate, thankYouNote);
            if (response) {
                setIsModalOpen(false);
                if (response.STATUS === "Fail") {
                    setAlertMessage(response.MESSAGE);
                    setshowErrorAlert(true);
                    setTimeout(() => setshowErrorAlert(false), 5000);
                } else {

                    setAlertMessage(response.MESSAGE);
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 5000);
                }
                setisOpenScheduleModal(false);
                setIsOpen(false);
                setSuccess(1);
                return;
            } else {
                setAlertMessage("error");
            }
        }
    }
    const handleDateCheckboxChange = () => {
        if (startImmediately) {
            setStartImmediately(false);
        } else {
            setStartImmediately(true);
        }
        if (!startImmediately) {
            setStartDate('');
            setStartTime('');
        }
    }
    const ChangeSuveryStatus = async () => {
        try {
            const response = await apiService.ChangeStatus(token, uniqueKey);
            if (response) {
                console.log(response);
                setSuccess(1);
            } else {

            }
        } catch (error) {
            throw error;
        }
    }
    const DeleteSurvey = async () => {
        try {
            const isConfirmed = window.confirm("Are you sure you want to delete this survey?");
            if (isConfirmed) {
                const response = await apiService.DeleteSurvey(token, uniqueKey);
                if (response) {
                    console.log(response);
                    navigate("/SurveyList");
                } else {
                    alert("not deleted")
                }
            }
        } catch (error) {
            throw error;
        }
    }
    ////Function to handle pie chart creation
    const createPieChart = (answers, chartId) => {
        const labels = answers.map(answer =>
            `${answer.Answer} [${answer.AnswerCount}]`
        );
        const dataValues = answers.map(answer => answer.AnswerPercentage);

        const chartData = {
            labels: labels,
            datasets: [{
                data: dataValues,
                backgroundColor: generateColors(labels.length),
                hoverBackgroundColor: generateColors(labels.length)
            }]
        };

        // Get chart context and render
        const ctx = document.getElementById(chartId).getContext('2d');
        new Chart(ctx, {
            type: 'pie',
            data: chartData,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                const value = tooltipItem.raw;
                                return `${tooltipItem.label}: ${value}%`;
                            }
                        }
                    }
                }
            }
        });
    };
    //// Function to generate dynamic colors based on number of options
    const generateColors = (num) => {
        const baseColors = [
            "rgb(63, 179, 144)", // Primary Green
            "#fc8e11", // Vibrant Orange
            "#00c49a", // Bright Mint Green
            "#ff6b35", // Bold Coral
            "#2ec4b6", // Modern Teal
            "#fcca46", // Soft Yellow-Orange
            "#3d5a80", // Deep Blue-Green
            "#98c1d9", // Muted Aqua
            "#ff5a5f", // Vibrant Red-Pink
            "#56ab2f", // Fresh Grass Green
            "#a1c181", // Soft Olive Green
            "#ffcc00", // Bright Yellow
            "#3c91e6", // Bold Sky Blue
            "#ff3f00", // Fiery Red-Orange
            "#5e60ce", // Vibrant Indigo
        ];
        return Array.from({ length: num }, (_, i) => baseColors[i % baseColors.length]);
    };
    const EndSurveyBtnClick = () => {
        try {
            const EndSurvey = async () => {
                const response = await apiService.EndSurvey(token, uniqueKey);
                if (response) {
                    setIsOpen(false);
                    setAlertMessage(response.MESSAGE);
                    setShowAlert(true);
                    setTimeout(() => setShowAlert(false), 4000);
                    setSuccess(1);
                } else {
                    alert("please try after some time");
                }
            }
            EndSurvey();
        } catch (error) {
            console.error(error);
        }
    }
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const CopySurveyClick = async () => {
        const response = await apiService.CopySurvey(token, uniqueKey);
        debugger
        try {
            if (response) {
                if (response.MESSAGE) {
                    alert(response.MESSAGE);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }
    const [qrDataUrl, setQrDataUrl] = useState("");
    const [showModal, setShowModal] = useState(false);
    const shareLink = `${window.location.origin}/ParticipantResponse/${uniqueKey}`;

    const handleShare = async (link) => {
        const shareData = {
            title: "Check this out!",
            text: "Here’s something interesting for you:",
            url: link,
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            navigator.clipboard.writeText(link);
            alert("Link copied to clipboard!");
        }
    };

    const generateQRCode = async () => {
        try {
            const dataUrl = await QRCode.toDataURL(shareLink);
            setQrDataUrl(dataUrl);
            setShowModal(true);
        } catch (err) {
            console.error("QR Code generation failed:", err);
        }
    };

    const handleDownload = () => {
        const a = document.createElement("a");
        a.href = qrDataUrl;
        a.download = "qr-code.png";
        a.click();
    };

    const handleCopyQR = async () => {
        const response = await fetch(qrDataUrl);
        const blob = await response.blob();
        await navigator.clipboard.write([
            new ClipboardItem({ "image/png": blob })
        ]);
        alert("QR code copied to clipboard!");
    };
    return (
        <>
            <Header />
            <div className="">
                {loading ? (
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    <div className="container-fuild">
                        <div className="bggrey p-2 h-95px">
                            <div className="row container ms-auto mx-auto h-100">
                                <div className="col-4 align-items-center d-flex">
                                    <h5><Link className="text-dark" to={"/SurveyList"}>Dashboard</Link>/    {SurveyName.length > 20
                                        ? `${SurveyName.slice(0, 20)}...`
                                        : SurveyName}</h5>
                                </div>
                                <div className="col-4 d-flex justify-content-around align-items-end">
                                    <a href="#" className={`fs-18 text-dark p-2 fw-6 ${activeTab === "Insights" ? "Manageactive" : ""}`} onClick={() => handleTabChange("Insights")}>Insights</a>
                                    <a href="#" className={`fs-18 text-dark p-2 fw-6 ${activeTab === "Survey" ? "Manageactive" : ""}`} onClick={() => handleTabChange("Survey")}>Survey</a>
                                    <a href="#" className={`fs-18 text-dark p-2 fw-6 ${activeTab === "Reports" ? "Manageactive" : ""}`} onClick={() => handleTabChange("Reports")}>Reports</a>
                                </div>
                                <div className="col-4 d-flex justify-content-evenly align-items-center">

                                    <button href="#" className="settingbtn border-0 br-5" onClick={toggleSidebar}><i className="fa-solid fa-gear"></i></button>

                                    {
                                        SurveyStatus === "Incomplete" && (<>
                                            <button href="#" className="text-secondary border-0 fs-22" disabled={CanEdit === 0} onClick={DeleteSurvey}><i className="fa-solid fa-trash"></i></button>
                                            <button
                                                className={`p-2 px-3 border-0 Gold br-5`}
                                                onClick={handleOpen}
                                            > publish</button>
                                            {/* <Button variant="contained" className="p-2 px-3 border-0 Gold br-5" onClick={handleOpen}>
                                                    Publish
                                                </Button> */}
                                        </>)
                                    }
                                    <Modal
                                        open={isModalOpen}
                                        onClose={handleClose}
                                        aria-labelledby="modal-title"
                                        aria-describedby="modal-description"
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                bgcolor: 'background.paper',
                                                borderRadius: 2,
                                                boxShadow: 24,
                                                p: 4,
                                                width: 600,
                                            }}
                                        >
                                            <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                                publish Survey
                                            </h4>
                                            <Typography id="modal-description" sx={{ mt: 2 }}>
                                                <div>
                                                    <div className="mb-3">
                                                        <label htmlFor="">Thank you note  <span className="text-danger">*</span> </label>
                                                        <textarea type="text" className="Sanket-Control" name="thankYouNote" value={thankYouNote} onChange={handleInputChange} />
                                                        {errors.thankYouNote && <small className="text-danger">{errors.thankYouNote}</small>}
                                                    </div>
                                                    <div className="row align-items-center mb-3">
                                                        <label htmlFor="">Start Date  <span className="text-danger">*</span></label>
                                                        <div className="col-6">
                                                            <input type="date" className="form-control" name="startDate" value={startDate} onChange={handleInputChange} disabled={startImmediately} />
                                                        </div>
                                                        <div className="col-6">
                                                            <input type="Time" className="form-control" name="startTime" value={startTime} onChange={handleInputChange} disabled={startImmediately} />
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
                                                            {errors.startTime && <small className="text-danger">{errors.startTime}</small>}
                                                        </div>
                                                        <div className="text-end mt-3">
                                                            <input type="checkbox" onChange={handleDateCheckboxChange} checked={startImmediately} /> <label>Start Immediately</label>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-center mb-3">
                                                        <label htmlFor="">End Date  <span className="text-danger">*</span></label>
                                                        <div className="col-6">
                                                            <input type="date" className="form-control" name="endDate" value={endDate} onChange={handleInputChange} />
                                                        </div>
                                                        <div className="col-6">

                                                            <input type="Time" className="form-control" name="endTime" value={endTime} onChange={handleInputChange} />
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            {errors.endDate && <small className="text-danger">{errors.endDate}</small>}
                                                            {errors.endTime && <small className="text-danger">{errors.endTime}</small>}
                                                        </div>

                                                    </div>
                                                </div>
                                            </Typography>
                                            <Box sx={{ mt: 3, display: 'flex' }}>
                                                <button className="text-dark ActionBtns" onClick={handleClose}>
                                                    Close
                                                </button>
                                                <button
                                                    className={`py-1 px-4 border-0 Gold br-5`}
                                                    onClick={HandletoPublish}
                                                > publish</button>
                                            </Box>
                                        </Box>
                                    </Modal>
                                    {SurveyStatus !== "Survey Ended" && (
                                        <>
                                            <button className="ActionBtns" onClick={() => handleShare(shareLink)}>
                                                <i className="fa-solid fa-share"></i>
                                            </button>
                                            <button className="ActionBtns" onClick={generateQRCode}>
                                                <i className="fa-solid fa-qrcode"></i>
                                            </button>
                                        </>
                                    )}

                                    {showModal && (
                                        <div style={{
                                            position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                                            background: "rgba(0,0,0,0.5)", display: "flex",
                                            alignItems: "center", justifyContent: "center", zIndex: 1000
                                        }}>
                                            <div style={{
                                                background: "#fff", padding: "20px", borderRadius: "10px",
                                                boxShadow: "0 0 10px rgba(0,0,0,0.3)", textAlign: "center", minWidth: "300px"
                                            }}>
                                                <h3>Share QR Code</h3>
                                                <img src={qrDataUrl} alt="QR Code" style={{ width: "200px", margin: "10px 0" }} />
                                                <Stack direction="row" spacing={2} justifyContent="center" marginTop={2}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: 'rgb(63, 179, 144)',
                                                            '&:hover': { backgroundColor: 'rgb(52, 153, 123)' }
                                                        }}
                                                        onClick={handleCopyQR}
                                                    >
                                                        Copy as PNG
                                                    </Button>

                                                    <Button
                                                        variant="outlined"
                                                        sx={{color: 'rgb(252, 142, 17)',borderColor: 'rgb(252, 142, 17)',
                                                            '&:hover': {backgroundColor: 'rgba(252, 142, 17, 0.1)',borderColor: 'rgb(252, 142, 17)'}
                                                        }}
                                                        onClick={handleDownload}
                                                    >
                                                        Download PNG
                                                    </Button>

                                                    <Button
                                                        variant="text"
                                                        sx={{color: 'rgb(120, 120, 120)',
                                                            '&:hover': {backgroundColor: 'rgba(0, 0, 0, 0.04)'}
                                                        }} onClick={() => setShowModal(false)}
                                                    >
                                                        Close
                                                    </Button>
                                                </Stack>
                                            </div>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
                            <div className="text-end">
                                <button className="closebtn" onClick={closeSidebar}><i className="fa-solid fa-xmark"></i></button>
                            </div>
                            <div className="overflow-auto">
                                <h5 className="text-center TruveyColor">Survey Details</h5>
                                <div>

                                    <ul className="text-dark">
                                        {
                                            (SurveyStatus === "Active" || SurveyStatus === "Scheduled to start") && (
                                                <>
                                                    <div className="mb-2">
                                                        <button className="btn btn-light" onClick={ChangeSuveryStatus}> Deactive Survey</button>
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            SurveyStatus === "Inactive" && (
                                                <>
                                                    <div className="mb-2">
                                                        <button className="btn btn-light" onClick={ChangeSuveryStatus}> Active Survey</button>
                                                    </div>
                                                </>
                                            )
                                        }
                                        <li className="nav-link mb-2">
                                            <Link to={`/Survey/AddPermission/${uniqueKey}`} className="text-dark btn btn-light">Add Permission</Link>
                                        </li>

                                        {
                                            SurveyStatus !== "Survey Ended" ? (<>
                                                <li className="nav-link mb-2">
                                                    <Link to={`/Survey/ManageReminder/${uniqueKey}`} className="text-dark btn btn-light">Manage Responder</Link>
                                                </li>
                                            </>) : (<></>)
                                        }

                                        {
                                            (SurveyStatus !== "Incomplete") && (<>
                                                <li className="nav-link mb-2">
                                                    <a href="#" className="text-dark btn btn-light" onClick={SchedulehandleOpen}>Edit Survey Schedule</a>
                                                </li>
                                            </>
                                            )}
                                        <Modal
                                            open={isOpenScheduleModal}
                                            onClose={SchedulehandleClose}
                                            aria-labelledby="modal-title"
                                            aria-describedby="modal-description"
                                        >
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    bgcolor: 'background.paper',
                                                    borderRadius: 2,
                                                    boxShadow: 24,
                                                    p: 4,
                                                    width: 600,
                                                }}
                                            >
                                                <h4 className="text-center" sx={{ mt: 2 }}>
                                                    Edit Schedule
                                                </h4>
                                                <Typography sx={{ mt: 2 }}>
                                                    <div>
                                                        <div>
                                                            <div className="mb-3">
                                                                <label htmlFor="">Thank you note  <span className="text-danger">*</span> </label>
                                                                <textarea type="text" className="Sanket-Control" name="thankYouNote" value={thankYouNote} onChange={handleInputChange} />
                                                                {errors.thankYouNote && <small className="text-danger">{errors.thankYouNote}</small>}
                                                            </div>
                                                            <div className="row align-items-center mb-3">
                                                                <label htmlFor="">Start Date  <span className="text-danger">*</span></label>
                                                                <div className="col-6">
                                                                    <input type="date" className="form-control" name="startDate" value={startDate} onChange={handleInputChange} disabled={SurveyStatus !== 'Scheduled to start'} />
                                                                    {errors.startDate && <small className="text-danger">{errors.startDate}</small>}
                                                                </div>
                                                                <div className="col-6">
                                                                    <input type="Time" className="form-control" name="startTime" value={startTime} onChange={handleInputChange} disabled={SurveyStatus !== 'Scheduled to start'} />
                                                                    {errors.startTime && <small className="text-danger">{errors.startTime}</small>}
                                                                </div>

                                                            </div>
                                                            <div className="row align-items-center mb-3">
                                                                <label htmlFor="">End Date  <span className="text-danger">*</span></label>
                                                                <div className="col-6">
                                                                    <input type="date" className="form-control" name="endDate" value={endDate} onChange={handleInputChange} />
                                                                    {errors.endDate && <small className="text-danger">{errors.endDate}</small>}
                                                                </div>
                                                                <div className="col-6">
                                                                    <input type="Time" className="form-control" name="endTime" value={endTime} onChange={handleInputChange} />
                                                                    {errors.endTime && <small className="text-danger">{errors.endTime}</small>}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </Typography>
                                                <Box sx={{ mt: 3, display: 'flex' }}>
                                                    <button className="text-dark ActionBtns" onClick={SchedulehandleClose}>
                                                        Close
                                                    </button>
                                                    <button
                                                        className={`py-1 px-4 border-0 Gold br-5 ${SurveyStatus === "Survey Ended" ? "bg-grey text-dark" : "Gold"}`}
                                                        onClick={HandletoPublish}
                                                        disabled={SurveyStatus === "Survey Ended"}
                                                    > Update Schedule</button>
                                                </Box>
                                            </Box>
                                        </Modal>
                                        <li className="nav-link mb-2">
                                            <a className="text-dark btn btn-light" onClick={CopySurveyClick}>Copy Survey</a>
                                        </li>
                                    </ul>
                                    {
                                        SurveyStatus === "Active" && (<>
                                            <div className="text-end mt-3">
                                                <button className={`border-0 Actionbtns px-3 ${IsEnded ? 'TruveyBG  text-white' : 'bg-grey text-secondary'}`} disabled={CanEnd === 0} onClick={EndSurveyBtnClick}>EndSurvey</button>
                                            </div>
                                        </>)
                                    }
                                </div>
                            </div>

                        </div>

                        {/* Overlay */}
                        <div className={`overlay ${isOpen ? 'open' : ''}`} onClick={closeSidebar}></div>
                        {renderTabContent()}
                        {showAlert && (
                            <>
                                <div className="AlertSet">
                                    <div className="alert alert-green" role="alert">
                                        <span className="fs-14">
                                            <span className="right me-2">
                                                <i className="fa-solid fa-check text-white"></i>
                                            </span>
                                            {alertMessage}
                                        </span>
                                        <sup>

                                            <button
                                                type="button"
                                                className="btn-close ms-3 fs-10"
                                                data-bs-dismiss="alert"
                                                aria-label="Close"
                                                onClick={() => setShowAlert(false)}
                                            ></button>
                                        </sup>
                                    </div>
                                </div>
                            </>
                        )}
                        {showErrorAlert && (
                            <>
                                <div className="AlertSet">
                                    <div className="alert alert-danger" role="alert">
                                        <span className="fs-14">
                                            <span className="right bg-danger text-white me-2">
                                                <i class="fa-solid fa-xmark"></i>
                                            </span>
                                            {alertMessage}
                                        </span>
                                        <sup>

                                            <button
                                                type="button"
                                                className="btn-close ms-3 fs-10"
                                                data-bs-dismiss="alert"
                                                aria-label="Close"
                                                onClick={() => setshowErrorAlert(false)}
                                            ></button>
                                        </sup>
                                    </div>
                                </div>
                            </>
                        )}

                        <button className="UpBtn" onClick={scrollToTop}>
                            <i className="fa-solid fa-arrow-up"></i>
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default ManageSurvey;
